import axios from '../axios/axios-auth'

export default class OperationsService {

    /**
     * V3
     **/
    getOperations(fieldId) {
        return axios.get(`/agro-service/v1/fields/${fieldId}/operations`).then(response => response.data);
    }

    getOperationStatistics(operationId, endpoint) {
        return axios.get(`/agro-service/v1/operations/${operationId}/${endpoint}`).then(response => response.data);
    }

    configMbtilesRaster(config) {
        return axios.post(`/track-tiles-service/v1/getMbtilesRaster`, config).then(response => response.data);
    }

    getInitialState(requestId, params) {
        return axios.get(`/track-tiles-service/v1/operationColors/${requestId}`, {params: params}).then(response => response.data);
    }

    requestExportFile(operationId, fileName) {
        return axios.post(`/agro-service/v1/manage/operations/${operationId}/export/${fileName}`).then(response => response.data);
    }

    getExportHistory(organizationId) {
        return axios.get(`/agro-service/v1/organizations/${organizationId}/exportHistory`).then(response => response.data);
    }

    downloadFile(operationId, exportRequestId) {
        return axios.get(`/agro-service/v1/operations/${operationId}/download/${exportRequestId}`, {responseType: 'blob'}).then(response => response);
    }

    sendKeepAlive(body) {
        return axios.post(`/track-tiles-service/v1/keepAlive`, body).then(response => response.data);
    }

    getOperationStatus(operationId) {
        return axios.get(`/agro-service/v1/operations/${operationId}/status`).then(response => response.data);
    }
}
